module.exports = __webpack_public_path__ + "img/jcyj_index2.b0a18702.jpg";